import React, { Component } from "react";
import classNames from "classnames";
import moment from "moment";
import { bool, func, instanceOf, objectOf, shape, string } from "prop-types";

import FieldError from "pages/_components/fields/FieldError";
import FieldLabel from "pages/_components/fields/FieldLabel";
import { DatePickerWithCustomInputLatestVersion as RangeDatePicker } from "pages/_components/fields/datepicker/";

import * as i18n from "util/i18n";

export class DateRangeField extends Component {
    static propTypes = {
        field: shape({ name: string }).isRequired,
        form: shape({ errors: objectOf(string), touched: objectOf(bool) }).isRequired,
        handleChange: func,
        hideLabel: bool,
        hidePlaceholder: bool,
        endDate: instanceOf(Object),
        maxDate: instanceOf(Object),
        minDate: instanceOf(Object),
        dateFormat: string,
        idForm: string,
        showDisabledMonthNavigation: bool,
        startDate: instanceOf(Object),
        showYearDropdown: bool,
        showMonthDropdown: bool,
        idField: string.isRequired,
        resetFilters: bool,
        handleResetDateFilters: func,
        showGlobalPlaceholder: bool,
        defaultLabel: string,
    };

    static defaultProps = {
        handleChange: () => {},
        hideLabel: false,
        hidePlaceholder: false,
        maxDate: new Date(),
        minDate: moment()
            .add(-6, "months")
            .toDate(),
        dateFormat: null,
        endDate: null,
        idForm: "",
        showDisabledMonthNavigation: true,
        startDate: null,
        showYearDropdown: false,
        showMonthDropdown: false,
        resetFilters: false,
        handleResetDateFilters: null,
        showGlobalPlaceholder: false,
        defaultLabel: null,
    };

    state = {
        isFocused: false,
    };

    validateDate = (selectedDate) => {
        const { maxDate, minDate } = this.props;
        if (selectedDate && minDate && moment(selectedDate).diff(minDate) < 0) {
            return false;
        }

        if (selectedDate && maxDate && moment(selectedDate).diff(maxDate >= 0)) {
            return false;
        }

        return true;
    };

    handleChange = (selectedDate) => {
        const { field, form, handleChange } = this.props;

        if (!this.validateDate(selectedDate)) {
            return;
        }

        if (handleChange) {
            handleChange(selectedDate);
        }

        form.setFieldValue(field.name, selectedDate);
    };

    onChangeRaw = (e) => {
        e.preventDefault();
    };

    render() {
        const { isFocused } = this.state;
        const {
            endDate,
            field,
            form: { touched, errors, setFieldValue },
            hideLabel,
            hidePlaceholder,
            idForm,
            maxDate,
            minDate,
            showDisabledMonthNavigation,
            startDate,
            dateFormat,
            idField,
            resetFilters,
            handleResetDateFilters,
            showGlobalPlaceholder,
            defaultLabel,
            ...rest
        } = this.props;

        if (resetFilters) {
            if (handleResetDateFilters) {
                handleResetDateFilters(false);
            }
            setFieldValue(field.name, null);
        }
        const hasError = touched && touched[field.name] && errors && errors[field.name];
        const placeholderText = showGlobalPlaceholder
            ? i18n.get("global.DateRange.placeholder")
            : i18n.get(`${idForm}.${field.name}.placeholder`);

        return (
            <div
                className={classNames("form-group", "form-group--datepicker", {
                    "has-error": hasError,
                    "has-focus": isFocused,
                })}>
                {!hideLabel && (
                    <FieldLabel
                        labelKey={`${idForm}.${field.name}.label`}
                        labelText={defaultLabel}
                        idField={field.name}
                    />
                )}
                <div className="input-group-standard">
                    <div className="form-control">
                        <RangeDatePicker
                            autoComplete="off"
                            dateFormat={dateFormat === null ? i18n.get("datepicker.format") : dateFormat}
                            className="form-control"
                            endDate={field.value[1] || endDate}
                            maxDate={maxDate}
                            minDate={minDate}
                            placeholderText={hidePlaceholder ? "" : placeholderText}
                            selected={field.value[0]}
                            preSelection={field.value[1] || field.value[0]}
                            showDisabledMonthNavigation={showDisabledMonthNavigation}
                            startDate={field.value[0] || startDate}
                            onChange={this.handleChange}
                            id={field.name}
                            onChangeRaw={this.onChangeRaw}
                            {...rest}
                        />
                    </div>
                </div>
                {hasError && <FieldError error={errors[field.name]} />}
            </div>
        );
    }
}

export default DateRangeField;
